import {
  Button,
  ListItemText,
  ListItem,
  ListItemIcon,
} from "@material-ui/core";
import React, { Fragment, useState, useRef, useEffect } from "react";
import styled from "styled-components";
import ConfigForm, { ConfigInput, FormOption } from "../ConfigForm";
import DottedOutlineButton from "../DottedOutlineButton";
import { Delete, Edit } from "@material-ui/icons";
import { v4 as uuid } from "uuid";
import Portal from "@material-ui/core/Portal";

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export interface AddlistItemsProps {
  options: FormOption[];
  onOptionAdd: (option: FormOption) => void;
  onOptionRemove: (option: FormOption) => void;
  onOptionEdit: (option: FormOption) => void;
}

interface AddListItemsState {
  addingItem: boolean;
  itemText: string;
}

const DEFAULT_STATE: AddListItemsState = {
  addingItem: false,
  itemText: "",
};
export default function AddlistItems({
  options,
  onOptionAdd,
  onOptionRemove,
  onOptionEdit,
}: AddlistItemsProps) {
  const [state, setState] = useState<AddListItemsState>(DEFAULT_STATE);
  const portalRef = useRef(null);
  const listIemAddInput: ConfigInput[] = [
    {
      title: "Item name",
      type: "text",
      onChange: (event: any) => {
        setState({ ...state, itemText: event.target.value });
      },
      xs: 12,
      sm: 12,
      id: "listItemName",
      value: state.itemText,
    },
  ];
  const itemAdd = state.addingItem ? (
    <Fragment>
      {/* <Portal container={portalRef.current}> */}
      <ConfigForm inputs={listIemAddInput} />
      {/* </Portal> */}
      <ButtonsContainer>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            setState(DEFAULT_STATE);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onOptionAdd({ value: uuid(), label: state.itemText });
            setState(DEFAULT_STATE);
          }}
        >
          Add
        </Button>
      </ButtonsContainer>
    </Fragment>
  ) : (
    <DottedOutlineButton
      title="Add item"
      handleClick={() => {
        setState({ ...state, addingItem: true });
      }}
    />
  );

  const inputRef = useRef();

  return (
    <Container>
      {options.map((option) => (
        <ListItem key={option.value} role={undefined} dense button>
          <ListItemText id={"value-" + option.value} primary={option.label} />
          <ListItemIcon>
            <Delete
              onClick={() => {
                onOptionRemove(option);
              }}
            />
            <Edit
              onClick={() => {
                onOptionEdit(option);
              }}
            />
          </ListItemIcon>
        </ListItem>
      ))}
      {itemAdd}
    </Container>
  );
}
